<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc sub"><a href="#/front03">Epigraph</a></p>
<p class="toc sub"><a href="#/front04">Introduction</a></p>
<p class="toc"><a href="#/c01">Be Like Mike</a></p>
<p class="toc"><a href="#/c02">The Great One</a></p>
<p class="toc"><a href="#/c03">Are the Games Dead?</a></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">Johnny Mac and Martina</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">The Trump Card</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">Larry Versus Magic</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">Heir Jordan</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">There’s a Draft in Here</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">Joy in Wrigleyville</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">Wax On, Wax Off</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">The Sham of Amateurism</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">Strokes of Genius</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">Photos</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">Swooshing In to Woo Jordan</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">Down Goes Tyson</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">The Dream Team</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">The Victory Tour</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">The All-Sports, All-the-Time Network</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">The Brawl to End It All</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">The Summer of the Mac</span></p>
<p class="toc"><span href="#/c21" title="Link target outside of Sample">Let the Games Begin</span></p>
<p class="toc"><span href="#/c22" title="Link target outside of Sample">Super Saturday</span></p>
<p class="toc"><span href="#/c23" title="Link target outside of Sample">Mike and Nike</span></p>
<p class="toc"><span href="#/c24" title="Link target outside of Sample">Wait Till Next Year</span></p>
<p class="toc"><span href="#/c25" title="Link target outside of Sample">Be Like Mike</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Notes</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc sub"><span href="#/back05" title="Link target outside of Sample">Index</span></p>
<p class="toc sub"><span href="#/back06" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back07" title="Link target outside of Sample">Connect on Social Media</span></p>
<p class="toc sub"><span href="#/footnotes" title="Link target outside of Sample">Footnotes</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?aeb8b6dc